import { ProjectTreeNodeT } from "components/project/layers/hooks";

import SystemFolderNode from "./SystemFolderNode";
import SystemRootNode from "./SystemRootNode";
import SystemShapefileNode from "./SystemShapefileNode";

export interface SystemStructuredNodeManagerProps {
  node: ProjectTreeNodeT;
}

export function SystemTreeNodeManager({ node }: SystemStructuredNodeManagerProps) {
  if (node.type === "root") {
    return <SystemRootNode node={node} />;
  } else if (node.type === "shapefile") {
    return <SystemShapefileNode node={node} />;
  } else if (node.type === "node") {
    return <SystemFolderNode node={node} />;
  } else {
    return null;
  }
}
